import { Placeholder } from "semantic-ui-react";

export default function TableCellPlaceholder() {
	return (
		<Placeholder style={{ width: "100%" }}>
			<Placeholder.Header>
				<Placeholder.Line />
			</Placeholder.Header>
		</Placeholder>
	);
}
